import { createAction, props } from "@ngrx/store"
import { NotificationsDto } from "src/app/data/dtos/notifications.dto"

export const getUnseenNotificationsData = createAction('[UnseenNotifications] getUnseenNotificationsData');
export const getUnseenNotificationsDataSuccess = createAction('[UnseenNotifications] getUnseenNotificationsData success', props<NotificationsDto>());
export const getUnseenNotificationsDataSuccessAlreadyLoaded = createAction('[UnseenNotifications] getUnseenNotificationsDataSuccessAlreadyLoaded success', props<NotificationsDto>());
export const getUnseenNotificationsDataFailure = createAction('[UnseenNotifications] getUnseenNotificationsData failure', props<{error: string}>());
export const removeUnseenNotifications = createAction('[UnseenNotifications] removeUnseenNotifications', props<{notificationIds: string[]}>());

export const restUnseenNotificationsData = createAction('[UnseenNotifications] restUnseenNotificationsData');


